// IMPORTED IMAGES
import logo from "../../../media/images/site-logo.png";

export default function Logo() {
    return (
        <div className="div-page-logo-container">
            <img src={logo} alt="Page Logo" />
            <span>Taskly</span>
        </div>
    );
}
